import { NgModule } from '@angular/core';
import { DropFilesZoneDirective } from './directives/drop-file-zone/drop-files-zone.directive';

@NgModule({
  declarations: [DropFilesZoneDirective],
  exports: [DropFilesZoneDirective],
})
export class DropFilesZoneModule {}
